// src/index.tsx
import { useCallback, useState } from "react";
import { InputGroup, Input, InputRightElement, Button, Flex } from "@chakra-ui/react";
import { Check } from "@airhelp/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var LinkGenerator = ({
  onClick,
  link,
  beforeCopyText,
  afterCopyText,
  copyButtonColor,
  dataTestId
}) => {
  const [didCopy, setDidCopy] = useState(false);
  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(link);
  }, [link]);
  const onClickCallback = useCallback(() => {
    if (onClick) {
      onClick();
    }
    copyToClipboard();
    setDidCopy(true);
  }, [copyToClipboard, onClick]);
  const basicButtonColor = copyButtonColor || "primary.500";
  const buttonColor = didCopy ? "success.600" : basicButtonColor;
  return /* @__PURE__ */ jsx(Flex, {
    children: /* @__PURE__ */ jsxs(InputGroup, {
      size: "lg",
      children: [
        /* @__PURE__ */ jsx(Input, {
          value: link,
          isReadOnly: true,
          name: "copy-link",
          width: "100%",
          borderColor: "greyscale.500",
          onClick: onClickCallback,
          textOverflow: "ellipsis"
        }),
        /* @__PURE__ */ jsx(InputRightElement, {
          width: "auto",
          children: /* @__PURE__ */ jsx(Button, {
            variant: "primary",
            backgroundColor: buttonColor,
            _hover: { backgroundColor: buttonColor },
            onClick: onClickCallback,
            borderStartRadius: "none",
            whiteSpace: "nowrap",
            leftIcon: didCopy ? /* @__PURE__ */ jsx(Check, {
              width: 5,
              height: 5,
              name: "Check"
            }) : void 0,
            maxHeight: "48px",
            "data-testid": dataTestId,
            _focus: { boxShadow: "none" },
            children: didCopy ? afterCopyText : beforeCopyText
          })
        })
      ]
    })
  });
};
export {
  LinkGenerator
};
